import { useEffect, useRef } from "react";

/**
 * Adds `is-visible` class to elements with `.reveal` once they enter the viewport.
 * Returns a ref to attach to the container whose children are revealed.
 */
export function useScrollReveal({ threshold = 0.15, rootMargin = "0px" } = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const root = ref.current || document;
    const nodes = root.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      nodes.forEach((n) => n.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold, rootMargin }
    );
    nodes.forEach((n) => io.observe(n));
    return () => io.disconnect();
  }, [threshold, rootMargin]);

  return ref;
}
